<template>
  <div class="investment">
    <TopBtns :setting.sync="drawerSetting" :convert.sync="modalConvert" :font-size.sync="fontSize" tab="investment" />
    <Search @search="searchInvestment" @searchReset="searchReset" @openSearchDrawer="openSearchDrawer" />
    <Sticky
      :property.sync="property"
      :select.sync="select"
      :search.sync="search"
      :search-status.sync="searchStatus"
      :font-size.sync="fontSize"
      type="investment"
      @search="searchInvestment"
      @outputCSV="outputInvestmentCSV"
    >
      <template v-slot:header>
        <ListTableHeader :font-size="fontSize" :table-scroll-x.sync="tableScrollX">
          <template v-slot:thead>
            <ListTableHeaderInvestment :table-col-width="tableColWidth" @search="searchInvestment" />
          </template>
        </ListTableHeader>
      </template>
    </Sticky>

    <ListTableInvestment
      :property.sync="property"
      :select.sync="select"
      :font-size.sync="fontSize"
      :table-col-width="tableColWidth"
      :table-scroll-x.sync="tableScrollX"
    />

    <!-- 設定ドロワー -->
    <DrawerSetting :drawer.sync="drawerSetting" :columns="columns" type="investment" />
    <!-- 詳細検索ドロワー -->
    <DrawerSearch :drawer.sync="DrawerSearch" type="investment" @search="searchInvestment" />
    <!-- コンバート一覧・結果モーダル -->
    <ModalConvertSummary
      :visible.sync="modalConvert"
      :initialWidth="480"
      :initialHeight="320"
      :initialPosition="[30, 30]"
      type="investment"
    />
    <!-- 住所から探すモーダル -->
    <ModalSearchByArea @search="searchInvestment" />
    <!-- 沿線から探すモーダル -->
    <ModalSearchByRailway @search="searchInvestment" />
    <!-- 物件コピーモーダル -->
    <ModalPropertyCopy @search="searchInvestment" />
    <!-- 保存した検索条件モーダル -->
    <ModalSearchConditions type="investment" @search="searchInvestment" />
    <!-- 検索条件保存モーダル -->
    <ModalSearchSave type="investment" @search="searchInvestment" />
    <!-- 簡易編集モーダル -->
    <ModalPropertyQuickEdit />
  </div>
</template>

<script>
import TopBtns from '@/components/templates/TopBtns'
import Search from '@/components/templates/Search'
import Sticky from '@/components/templates/Sticky'
import ListTableHeader from '@/components/templates/ListTableHeader'
import ListTableHeaderInvestment from '@/components/templates/ListTableHeaderInvestment'
import ListTableInvestment from '@/components/templates/ListTableInvestment'
import DrawerSetting from '@/components/templates/drawer/Setting'
import DrawerSearch from '@/components/templates/drawer/SearchDrawer'
import ModalConvertSummary from '@/components/templates/modal/ConvertSummary/Index'
import ModalSearchByArea from '@/components/templates/modal/SearchByArea'
import ModalSearchByRailway from '@/components/templates/modal/SearchByRailway'
import ModalSearchConditions from '@/components/templates/modal/SearchConditions'
import ModalSearchSave from '@/components/templates/modal/SearchSave'
import ModalPropertyCopy from '@/components/templates/modal/PropertyCopy'
import ModalPropertyQuickEdit from '@/components/templates/modal/PropertyQuickEdit'
import SearchProperty from '@/mixins/search'
import CSV from '@/mixins/csv'
import SettingRepository from '@/repositories/settingRepository'
import ColumnInvestment from '@/constants/column_investment'
export default {
  mixins: [SearchProperty, CSV],
  components: {
    TopBtns,
    Search,
    Sticky,
    ListTableHeader,
    ListTableHeaderInvestment,
    ListTableInvestment,
    DrawerSetting,
    DrawerSearch,
    ModalConvertSummary,
    ModalSearchByArea,
    ModalSearchByRailway,
    ModalSearchConditions,
    ModalSearchSave,
    ModalPropertyCopy,
    ModalPropertyQuickEdit,
  },
  data() {
    return {
      drawerSetting: false,
      DrawerSearch: false,
      modalConvert: false,
      modalImagePreview: false,
      previewImages: [],
      columns: ColumnInvestment,
      fontSize: 10,
      tableScrollX: 0,
      tableColWidth: {
        col1: 40,
        col2: 120,
        col3: 180,
        col4: 180,
        col5: 180,
        col6: 120,
        col7: 120,
        col8: 120,
        col9: 120,
        col10: 120,
        col11: 120,
        col12: 180,
        col13: 100,
        col14: 180,
        col15: 180,
        col16: 100,
        col17: 180,
        col18: 100,
      },
    }
  },
  computed: {
    user() {
      return this.$store.getters['User/getUser']
    },
    property: {
      get() {
        return this.$store.getters['Property/getProperty']
      },
      set(val) {
        this.$store.commit('Property/setProperty', val)
      },
    },
    select: {
      get() {
        return this.$store.getters['SelectProperty/getProperty']
      },
      set(val) {
        this.$store.commit('SelectProperty/setProperty', val)
      },
    },
    search: {
      get() {
        return this.$store.getters['SearchProperty/getSearch']
      },
      set(val) {
        this.$store.commit('SearchProperty/setSearch', val)
      },
    },
    searchStatus: {
      get() {
        return this.$store.getters['SearchProperty/getStatus']
      },
      set(val) {
        this.$store.commit('SearchProperty/setStatus', val)
      },
    },
  },
  created() {
    // 物件一覧、物件選択リスト、検索条件のリセット処理
    this.$store.dispatch('Property/reset')
    this.$store.dispatch('Tag/reset')
    this.$store.dispatch('SearchProperty/reset')
    this.$store.dispatch('SelectProperty/reset')
    this.getColumns()
  },
  mounted() {
    window.addEventListener('message', this.onMadorinosukeSaved)
  },
  beforeDestroy() {
    window.removeEventListener('message', this.onMadorinosukeSaved)
  },
  watch: {
    $route: function(to, from) {
      if (from.meta.type !== to.meta.type) {
        // タイプが違う場合は物件一覧、物件選択リスト、検索条件をリセットする
        this.$store.dispatch('Property/reset')
        this.$store.dispatch('Tag/reset')
        this.$store.dispatch('SearchProperty/reset')
        this.$store.dispatch('SelectProperty/reset')
      }
    },
  },
  methods: {
    onMadorinosukeSaved(event) {
      const expectedOrigin = new URL(
        process.env.VUE_APP_MADORINOSUKE_URL
      ).origin

      if (event.origin !== expectedOrigin) return
      if (event.data?.type !== 'MADORINOSUKE_SAVED') return
      if (!/^s-\d+$/.test(String(event.data.roomId))) return

      const currentPage = this.searchStatus.current_page || 1
      this.searchProperty('investment', currentPage)
    },
    // 検索処理
    searchInvestment(page = 1) {
      this.searchProperty('investment', page)
    },
    // 検索条件リセット
    searchReset() {
      this._searchReset()
    },
    // 詳細検索ドロワーを開く
    openSearchDrawer() {
      this.DrawerSearch = true
    },
    async getColumns() {
      this.$store.dispatch('Loading/setLoading', true)
      await SettingRepository.getColumns('investment')
        .then(data => {
          if (data.result) {
            this.$store.commit('Column/setColumns', data.data)
            this.$store.commit('Column/setIsShow', true)
          } else {
            this.$router.push({ name: `error` })
          }
        })
        .catch(() => {
          this.$router.push({ name: `error` })
        })
        .finally(() => {
          this.$store.dispatch('Loading/setLoading', false)
        })
    },
    outputInvestmentCSV() {
      this.outputCSV('investment')
    },
  },
}
</script>

<style lang="scss" scoped></style>
